'use client';

import { PropsWithChildren, useEffect, useRef } from 'react';
import { StyledDiv } from '../../common/components/styled-div';
import { Typography } from '../../atoms/typography/typography';
import { Button } from '../../atoms/button/button';
import { Spacing } from '../../atoms/spacing/spacing';
import styled from '@emotion/styled';
import { ErrorBoundary, useErrorBoundary } from 'react-error-boundary';
import { useNavigate } from 'react-router-dom';
interface ErrorBoundaryProps extends PropsWithChildren {
  onError: (data: Error) => void;
}

export const ErrorBoundaryScreen = ({
  onError,
  children,
}: ErrorBoundaryProps) => {
  const navigate = useNavigate();

  return (
    <ErrorBoundary
      onError={onError}
      FallbackComponent={() => <ErrorFallBackUi />}
      onReset={() => {
        navigate('/');
      }}
    >
      {children}
    </ErrorBoundary>
  );
};

export const ErrorFallBackUi = () => {
  const { resetBoundary } = useErrorBoundary();

  return (
    <>
      <StyledDiv
        flexDirection="column"
        justifyContent="center"
        alignItem="center"
        height="100vh"
      >
        <Spacing marginBottom="xxl">
          <StyledComponent variant="textTitleLarge" data-cy="error-message">
            Oops! something <br />
            went wrong
          </StyledComponent>
        </Spacing>

        <Button
          onClick={() => {
            resetBoundary();
          }}
          variant="filled"
          children="Go Back"
          data-cy="go-back-button"
        />
      </StyledDiv>
    </>
  );
};

const StyledComponent = styled(Typography)`
  text-align: center;
`;
